var map = {
	"./auth.js": "11c0",
	"./customer.js": "37f8",
	"./identification-type.js": "4a91",
	"./layout.js": "c21a",
	"./loading.js": "5a5e",
	"./menu.js": "0978",
	"./notification.js": "2208",
	"./permission.js": "c70c",
	"./product-category.js": "9649",
	"./role.js": "f9c8",
	"./store.js": "5c9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";